<template lang="pug">
div
  slot(
    :verified='verified'
    :check='checkTickets'
    :reset='checkVerification'
    :phone='phone'
    :save='save'
  )
</template>

<script>
import { checkTickets } from '@api/ticket_management.service'

import {
  setCookie,
} from '@utils/cookies'

import { TOTIS_2_BUYER_TOKEN, TOTIS_2_BUYER_ID_TOKEN } from '@/app'

export default {
  name: 'TicketCheck',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      verified: false,
      phone: '',
      data: {
        id_token: '',
        phone: '',
      },
    }
  },
  // created() {
  //   this.checkVerification()
  // },
  methods: {
    checkVerification() {
      this.verified = false
      // this.checkTickets()
      this.phone = this.data.phone
      // if (this.verified) {
      // }
    },
    async checkTickets() {
      this.phone = this.data.phone
      try {
        const { data } = (await checkTickets.execute({
          label: this.label,
        }, {
          buyer: this.data.id_token,
        }))
        if (data.length) {
          setCookie(TOTIS_2_BUYER_ID_TOKEN, this.data.id_token)
          setCookie(TOTIS_2_BUYER_TOKEN, this.data.phone)
          this.verified = false
          window.location.href = `${window.location.href}tickets/${this.data.id_token}/`
        } else {
          this.verified = true
        }
      } catch (error) {
        console.error('Error checking tickets:', error)
      }
    },
    save(data) {
      this.data = data
    },
  },
}
</script>
